import axios from 'axios';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const UGC_SubjectModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    let initialData = {
        Subject: '',
        ExamType: 'Select Section',
        DisplayOrder: 0
    }


    const [examBodyData, setExamBodyData] = useState(initialData);


    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            console.log(item)
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.Subject.trim().length === 0) {
                toast.error("Please Enter Subject Name")
                return;
            } else if (examBodyData.ExamType.trim().length === 0 || examBodyData.ExamType === 'Select Section') {
                toast.error("Please select section")
                return;
            }
            const response = axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/ugc/createSubject' : `/ugc/updateSubject`}`, examBodyData);
            console.log(response)
            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);

        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }

    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Subject" : "Create Subject"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">SECTION TYPE<span className="required">*</span></label>
                            <Select
                                value={{
                                    value: examBodyData.ExamType,
                                    label: examBodyData.ExamType === 'GENERAL APTITUDE' ? 'Teaching & Research Aptitude' : examBodyData.ExamType === 'SUBJECT SPECIFIC' ? 'Academic Subjects' : examBodyData.ExamType
                                }}
                                onChange={(selectedOption) => setExamBodyData({ ...examBodyData, ExamType: selectedOption.value })}
                                options={[
                                    { value: 'SUBJECT SPECIFIC', label: 'Academic Subjects' },
                                    { value: 'GENERAL APTITUDE', label: 'Teaching & Research Aptitude' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="subjects" value={examBodyData.Subject} onChange={(e) => setExamBodyData({ ...examBodyData, Subject: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="displayOrder" className="form-label text-primary">ORDER PREFERENCE</label>
                            <input className='form-control' type="number" min="0" id="displayOrder" value={examBodyData.DisplayOrder} onChange={(e) => setExamBodyData({ ...examBodyData, DisplayOrder: e.target.value })} placeholder="e.g. 1, 2, 3... (0 for alphabetical)" />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Create "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default UGC_SubjectModal;